// API Configuration
// This file centralizes all API URL configuration

const _API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Remove '/api' suffix if present to get base URL
const BASE_URL = _API_BASE_URL.replace(/\/api$/, '');

export const API_CONFIG = {
  BASE_URL: BASE_URL,
  API_URL: _API_BASE_URL,

  // Endpoint builders
  LEADS: `${_API_BASE_URL}/leads`,
  EMPLOYEES: `${_API_BASE_URL}/employees`,
  NOTIFICATIONS: `${_API_BASE_URL}/notifications`,
  TOUR_PACKAGES: `${_API_BASE_URL}/tour-packages`,
  MASTER_DATA: `${_API_BASE_URL}/master-data`,
  UPLOAD: `${_API_BASE_URL}/upload`,
  FOLLOW_UP: `${_API_BASE_URL}/follow-up`,
  BRANCHES: `${_API_BASE_URL}/branches`,
  SERVICE_MASTER: `${_API_BASE_URL}/service-master`,
  BRANCH_AUTH: `${_API_BASE_URL}/branch-auth`,
  BRANCH_TRACKING: `${_API_BASE_URL}/branch-tracking`,

  // Additional endpoints
  FORM_FIELDS: '/form-fields',
  DROPDOWN_OPTIONS: '/dropdown-options',
  QUOTATIONS: '/quotations',
  USER_SETTINGS: '/user-settings',
  COMPANY_AUTH: '/company-auth',
  EMPLOYEE_AUTH: '/employee-auth',

  // Dynamic endpoint functions
  LEAD_BY_ID: (id) => `/leads/${id}`,
  EMPLOYEE_BY_ID: (id) => `/employees/${id}`,
  NOTIFICATION_BY_ID: (id) => `/notifications/${id}`,
};

// Helper function to build full URL
export const buildApiUrl = (endpoint) => {
  if (endpoint.startsWith('http')) {
    return endpoint; // Already a full URL
  }
  if (endpoint.startsWith('/')) {
    return `${BASE_URL}${endpoint}`;
  }
  return `${_API_BASE_URL}/${endpoint}`;
};

// Export as API_ENDPOINTS for backward compatibility
export const API_ENDPOINTS = API_CONFIG;

// Export API_BASE_URL for backward compatibility
export { _API_BASE_URL as API_BASE_URL };

// Export authApi for backward compatibility (auth endpoints)
export const authApi = {
  login: `${_API_BASE_URL}/auth/login`,
  register: `${_API_BASE_URL}/auth/register`,
  companyLogin: `${_API_BASE_URL}/company-auth/login`,
  employeeLogin: `${_API_BASE_URL}/employee-auth/login`,
  branchLogin: `${_API_BASE_URL}/branch-auth/login`,
};

// Export localApi for backward compatibility (same as authApi)
export const localApi = authApi;

export default API_CONFIG;
